import { useEffect, useState } from 'react';
import type { AuthMethods } from '@kratispot/shared';
import { fetchAuthMethods } from '@/lib/api';

// Unreachable means "nothing offered": a door that cannot open is worse than none.
const NONE: AuthMethods = { googleEnabled: false, magicLinkEnabled: false };

export function useAuthMethods(): AuthMethods {
  const [methods, setMethods] = useState<AuthMethods>(NONE);

  useEffect(() => {
    const controller = new AbortController();
    fetchAuthMethods(controller.signal)
      .then(setMethods)
      .catch(() => undefined);
    return () => controller.abort();
  }, []);

  return methods;
}
